export enum LoyaltyRouteNames {
  LOYALTY_ROOT = 'LoyaltyRoot',

  CAMPAIGNS_LIST = 'LoyaltyRoot/Campaigns',
  CAMPAIGNS_CREATE = 'LoyaltyRoot/Campaigns/Create',
  CAMPAIGNS_DETAIL = 'LoyaltyRoot/Campaigns/Detail',
  CAMPAIGNS_EDIT = 'LoyaltyRoot/Campaigns/Edit',

  VOUCHERS_LIST = 'LoyaltyRoot/Vouchers',
  VOUCHERS_CREATE = 'LoyaltyRoot/Vouchers/Create',
  VOUCHERS_DETAIL = 'LoyaltyRoot/Vouchers/Detail',

  PROGRAMS_LIST = 'LoyaltyRoot/Programs',
  PROGRAMS_CREATE = 'LoyaltyRoot/Programs/Create',
  PROGRAMS_DETAIL = 'LoyaltyRoot/Programs/Detail',
  PROGRAMS_EDIT = 'LoyaltyRoot/Programs/Edit',
  PROGRAMS_CARD_DETAIL = 'LoyaltyRoot/Programs/CardDetail',

  SEGMENTS_LIST = 'LoyaltyRoot/Segments',
  SEGMENTS_CREATE = 'LoyaltyRoot/Segments/Create',
  SEGMENTS_DETAIL = 'LoyaltyRoot/Segments/Detail',

  REPORTING_CAMPAIGNS = 'LoyaltyRoot/Reporting/Campaigns',
  REPORTING_CUSTOMERS = 'LoyaltyRoot/Reporting/Customers',
}
